const actions = {
  GET_ADMIN_GRAPH: "statistic/GET_ADMIN_GRAPH",
  SET_ADMIN_GRAPH: "statistic/SET_ADMIN_GRAPH",
};

export default actions;
